import React from 'react';
import loadingIcon from './assets/loadingIcon.svg';
import nawatechLogo from './assets/nawatech-logo.png';

const LoadingPage = () => {
    return (
        <div className="not-found-container">
            <img src={nawatechLogo} style={{ height: "60px" }} />
            <div className='loading-indicator'>
                <img src={loadingIcon} alt="loading" />
            </div>
        </div>
    );
};

export default LoadingPage;